import { TFunction } from "i18next"
import { mixed } from 'yup'
import { MixedSchema } from 'yup'
import {
  checkFileType,
  dropZoneTranslations,
  prettySize,
  readableFileTypes,
} from '@/Shared/ui/DropZone'

export const fileSchema = (
  t: TFunction<'translation', undefined>,
  validFileFormat: string | string[],
  maxFileSize: number
) : MixedSchema<FileList | null | undefined> =>
  mixed<FileList>()
    .test(
      'file-exists',
      t(dropZoneTranslations.validation.fileExists),
      value => value != null && value.length > 0
    )
    .test(
      'file-format',
      t(dropZoneTranslations.validation.fileFormat, {
        fileTypes: readableFileTypes(validFileFormat).join(
          t(dropZoneTranslations.formatOr)
        ),
      }),
      value =>
        value != null && value.length > 0
          ? checkFileType(value[0], validFileFormat)
          : true
    )
    .test(
      'file-size',
      t(dropZoneTranslations.validation.fileSize, {
        fileSize: prettySize(maxFileSize),
      }),
      value => (value != null && value.length > 0 ? value[0].size < maxFileSize : true)
    )
